import { parse, SymbolNode } from 'mathjs';

/**
 * Migrate old coefficient names (a, b, c) to new format (g1, g2, g3)
 * @param data - DecisionData object to be migrated
 */
export function migrateIndicatorCoefficients(data: any) {
  if (!data.objectives) return;

  data.objectives.forEach(
    (objective: {
      indicatorData?: {
        customAggregationFormula?: string;
      };
    }) => {
      if (objective.indicatorData?.customAggregationFormula) {
        objective.indicatorData.customAggregationFormula = migrateFormulaToNewCoefficients(
          objective.indicatorData.customAggregationFormula,
        );
      }
    },
  );
}

export function migrateFormulaToNewCoefficients(formula: string): string {
  try {
    const parsedFormula = parse(formula);
    let foundOldIndicatorWeight = false;

    parsedFormula.traverse((node, path, parent) => {
      if (node.type === 'SymbolNode') {
        if (parent?.type === 'FunctionNode' && (parent as any).fn === node) {
          return;
        }

        const symbolNode = node as SymbolNode;

        if (/^[a-z]+$/.test(symbolNode.name)) {
          const index = letterToIndex(symbolNode.name);
          symbolNode.name = `g${index}`;
          foundOldIndicatorWeight = true;
        }
      }
    });

    if (foundOldIndicatorWeight) {
      return parsedFormula.toString();
    }

    return formula;
  } catch (e) {
    return formula;
  }
}

function letterToIndex(str: string): number {
  let result = 0;
  for (let i = 0; i < str.length; i++) {
    result *= 26;
    result += str.charCodeAt(i) - 96;
  }
  return result;
}
